import { Stack, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const RequirementsHeader = () => {
    return (
        <Stack data-testid="requirements-header">
            <Text className="text-3xl font-bold">
                <FormattedMessage
                    id="_.funding_requirements.list.title"
                    defaultMessage="Complete your final checks"
                />
            </Text>
            <Text className="text-l">
                <FormattedMessage
                    id="_.funding_requirements.list.subheading"
                    defaultMessage="Before we can send funds to your account, we need you to complete a few final steps."
                />
            </Text>
        </Stack>
    );
};
